import { render, staticRenderFns } from "./TrendData.vue?vue&type=template&id=3ebdeb5e&scoped=true"
import script from "./TrendData.vue?vue&type=script&lang=js"
export * from "./TrendData.vue?vue&type=script&lang=js"
import style0 from "./TrendData.vue?vue&type=style&index=0&id=3ebdeb5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebdeb5e",
  null
  
)

export default component.exports